import { render, staticRenderFns } from "./FixedDeliveryDetail.vue?vue&type=template&id=319738e9&scoped=true"
import script from "./FixedDeliveryDetail.vue?vue&type=script&lang=js"
export * from "./FixedDeliveryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319738e9",
  null
  
)

export default component.exports